module.exports = __webpack_public_path__ + "img/404.983f6860.svg";